import { of, EMPTY } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import { employee$ as baseEmployee$ } from '@apiEnabler/ob-common/lib/employee'

const uiConfig = window.ui || {}
const isStaffMember = uiConfig.mode === 'staff'
const STAFF_PORTAL_HOST = uiConfig.staffPortalHost || ''
const staffPortalSearchQuery = isStaffMember ? getPortalSearchQuery() : ''
if (isStaffMember) {
  localStorage.setItem('staffPortalSearchQuery', staffPortalSearchQuery)
}

function getPortalSearchQuery() {
  const queryParams = window.location.search || ''
  const hasBrandParam = queryParams.indexOf('brand=') !== -1
  const hasCinParam = queryParams.indexOf('cin=') !== -1
  const hasTypeParam = queryParams.indexOf('customerType=pbb') !== -1

  if (hasBrandParam && hasCinParam && hasTypeParam) {
    return queryParams
  } else {
    return localStorage.getItem('staffPortalSearchQuery') || ''
  }
}

const isStaffMember$ = of(isStaffMember)

const staffPortalSearchQuery$ = isStaffMember
  ? of(staffPortalSearchQuery)
  : of('')

const employee$ = isStaffMember$.pipe(
  switchMap(isStaffMember => (isStaffMember ? baseEmployee$ : EMPTY))
)

export {
  isStaffMember,
  isStaffMember$,
  staffPortalSearchQuery$,
  employee$,
  STAFF_PORTAL_HOST,
}
